module.exports = __webpack_public_path__ + "static/media/food5.bd0afee2.png";